import React, { useEffect, useState } from "react";
import classes from "./CardRegistration.module.scss";
import apiClient from "../../lib/apiClient";
import logo from "../../assets/logo.svg";
import { useCardAccessor } from "../../hooks/useCardAccessor";
import {
  Box,
  CircularProgress,
  Dialog,
  Divider,
  FormControlLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { completeDatePtList, completeDatePvList } from "../../commons/endDate";
import DialogButton from "../uikit/atoms/buttons/card/DialogButton";
import TextInputForCard from "../uikit/atoms/textFields/TextInputForCard";
import {
  backGroundColorCode,
  foreColor,
  foreColorCode,
  foreColorCodeLite,
  foreColorOnMouseOver,
  backgroundColor,
  backgroundColorDnd,
} from "../../commons/colors";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userState } from "../../states/userState";
import { loadingState, loadingText } from "../../states/loadingState";

type apiParamsType = {
  id: string;
  compDate: string;
  cardId: string;
  cardType: string;
};

const CardRegistration = () => {
  const {
    isPolling,
    isDetected,
    CardReaderActive,
    CardReaderStop,
    displayMessage,
    cardId,
    cardType,
    isUSBConnected,
  } = useCardAccessor();
  const [completeDateList, setCompleteDateList] = useState([
    ...completeDatePtList,
    ...completeDatePvList,
  ]);
  const user = useRecoilValue(userState);
  const [isApiExecuting, setIsApiExecuting] = useState(false);
  const [isFound, setIsFound] = useState(false);
  const [compDate, setCompDate] = useState("未登録");
  const [apiParams, setApiParams] = useState<apiParamsType>({
    id: "",
    compDate: "",
    cardId: "",
    cardType: "",
  });
  const [isShowForm, setIsShowForm] = useState(false);
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  //kintoneAPIコール-カード検出時
  useEffect(() => {
    const executeApi = async () => {
      setIsApiExecuting(true);
      setLoadingAnimation(true);
      setLoadingText("読み込み中...");
      try {
        console.log("送信前", cardId, cardType);
        //カード検索
        const query = `cardId=${encodeURIComponent(cardId)}`;
        console.log("query", query);
        let response = await apiClient.get(`/cards/getcards/?${query}`);
        const lIsFound = response.data.length > 0;
        const cardData = response.data[0];
        console.log("response", response.data);
        setIsFound(lIsFound);
        if (lIsFound) {
          //カードが登録済みの場合-工程（完了日）を取得
          // const send_data = [cardId, cardType, cardData["$id"].value];
          // let json_wrapper = { data: send_data };
          // response = await apiClient.put("/cards/update_card", json_wrapper);
          // console.log(response);
          setApiParams({
            id: cardData["$id"].value,
            compDate: cardData.processName.value,
            cardId: cardData.card_id.value,
            cardType: cardData.card_type.value,
          });
          setCompDate(cardData.processName.value);
        } else {
          console.log("okk");
          setCompDate("未登録");
          setApiParams({
            id: "",
            compDate: "未登録",
            cardId: cardId,
            cardType: cardType,
          });
          //カードが登録されていない場合（未登録をセット）
          // const send_data = [cardId, cardType];
          // let json_wrapper = { data: send_data };
          // response = await apiClient.post(
          //   "/cards/postcards",
          //   json_wrapper
          // );
        }
      } catch (e) {
        alert(e);
      } finally {
        setLoadingAnimation(false);
        setLoadingText("");
        setIsApiExecuting(false);
      }
    };
    if (isDetected == true && !isApiExecuting) {
      //カード検出かつAPI実行中でない場合
      executeApi();
    }
  }, [isDetected]);
  //kintoneAPIコール-カード追加時
  const addCardInfo = async () => {
    try {
      setIsApiExecuting(true);
      setLoadingAnimation(true);
      setLoadingText("登録中...");
      //カードが登録されていない場合（未登録をセット）
      const send_data = [
        apiParams.cardId,
        apiParams.cardType,
        apiParams.compDate,
      ];
      let json_wrapper = { data: send_data };
      const response = await apiClient.post("/cards/postcards", json_wrapper);
    } catch (e) {
      alert(e);
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
      setIsApiExecuting(false);
    }
  };
  //kintoneAPIコール-カード更新時
  const updateCardInfo = async () => {
    try {
      setIsApiExecuting(true);
      setLoadingAnimation(true);
      setLoadingText("更新中...");
      //カードが登録されていない場合（未登録をセット）
      const send_data = [
        apiParams.cardId,
        apiParams.cardType,
        apiParams.compDate,
        apiParams.id,
      ];
      let json_wrapper = { data: send_data };
      const response = await apiClient.put("/cards/update_card", json_wrapper);
    } catch (e) {
      alert(e);
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
      setIsApiExecuting(false);
    }
  };
  const onClickCardReaderActive = async () => {
    await CardReaderActive();
    setCompDate("未登録");
    setIsShowForm(false);
  };
  const onClickCardReaderStop = async () => {
    await CardReaderStop();
    setCompDate("未登録");
    setIsShowForm(false);
  };
  const handleOKButtonClick = async () => {
    if (isFound) {
      await updateCardInfo();
    } else {
      await addCardInfo();
    }
    setApiParams({ id: "", compDate: "", cardId: "", cardType: "" });
    await CardReaderActive();
    setIsShowForm(false);
  };
  const handleCancelButtonClick = async () => {
    setApiParams({ id: "", compDate: "", cardId: "", cardType: "" });
    await CardReaderActive();
    setIsShowForm(false);
  };
  const handleSelectBoxChange = (value: string) => {
    console.log(value);
    // const selectedValue = e.target.value;
    setCompDate(value);
    setApiParams((prevState) => {
      return { ...prevState, compDate: value };
    });
  };
  //カード検出時のポーリング停止
  useEffect(() => {
    const stopPolling = async () => {
      await CardReaderStop();
    };
    if (isPolling && isDetected) {
      setIsShowForm(true);
      stopPolling();
    }
  }, [isDetected, isPolling]);
  //クリーンアップ
  useEffect(() => {
    const cleanup = async () => {
      await CardReaderStop();
      await onClickCardReaderStop();
    };
    return () => {
      cleanup();
    };
  }, []);
  useEffect(() => {
    console.log("compDate", compDate);
  }, [compDate]);

  return (
    //ポーリング中
    //ポーリング停止かつ、ICカード検出
    //ポーリング停止かつ、ICカード未検出
    <>
      {!isPolling && !isDetected && !isShowForm && (
        <div className={classes.cardReaderButton}>
          <img src={logo} className={classes.Applogo} alt="logo" />
          <div className={classes.spacerMinimum} />
          <DialogButton
            label={"カードリーダ起動"}
            disabled={false}
            width={160}
            onClick={onClickCardReaderActive}
            colorStyle={"yesColor"}
          />
          <div className={classes.spacerMinimum} />
          <button
            className="uk-button uk-button-large uk-button-default uk-width-1-1"
            style={
              isUSBConnected === false
                ? {
                    color: "red",
                    border: "none",
                    ...backgroundColorDnd(user?.mode ?? "lite"),
                  }
                : {
                    ...foreColor(user?.mode ?? "lite"),
                    border: "none",
                    ...backgroundColorDnd(user?.mode ?? "lite"),
                  }
            }
            disabled
          >
            {isUSBConnected === false
              ? "ICカードリーダが接続されていません"
              : "ICカードリーダを起動してください"}
          </button>
        </div>
      )}
      {isPolling && (
        <div className={classes.cardReaderButton}>
          <img src={logo} className={classes.Applogo} alt="logo" />
          <div className={classes.spacerMinimum} />
          <DialogButton
            label={"カードリーダ停止"}
            disabled={false}
            width={160}
            onClick={onClickCardReaderStop}
            colorStyle={"yesColor"}
          />
          <div className={classes.spacerMinimum} />
          <button
            className="uk-button uk-button-large uk-button-default uk-width-1-1"
            style={{
              ...foreColor(user?.mode ?? "lite"),
              border: "none",
              ...backgroundColorDnd(user?.mode ?? "lite"),
            }}
            disabled
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ marginRight: "5px" }}>
                <CircularProgress
                  size="1.2rem"
                  sx={foreColor(user?.mode ?? "lite")}
                />
              </div>
              <div>{displayMessage}</div>
            </div>
          </button>
        </div>
      )}
      {isShowForm && (
        <div className={classes.root}>
          <Stack spacing={2}>
            <Divider
              textAlign="center"
              variant="fullWidth"
              sx={{
                borderColor: foreColorCode(user?.mode ?? "lite"), // 線の色をテーマのプライマリーカラーに設定
                fontSize: "18px",
                // marginBottom: "50px",
                // Dividerにテキストがある場合、テキストのスタイルもここで定義できます
                "&::before, &::after": {
                  // Dividerの線のスタイルをカスタマイズ
                  borderTopColor: foreColorCode(user?.mode ?? "lite"), // これにより、線の色が変わります
                },
                color: foreColorCode(user?.mode ?? "lite"), // テキストの色を変更
                "@media (max-width: 600px)": {
                  fontSize: "14px", // フォントサイズを14pxに設定
                },
              }}
            >
              {isFound ? "【登録済み】" : "【新規登録】"}
            </Divider>
            <div className={classes.spacer} />
            <div className={classes.cardInfo}>
              <div style={foreColor(user?.mode ?? "lite")}>IDm・ID</div>
              <div className={classes.textField}>
                <TextInputForCard
                  fullWidth={false}
                  label={""}
                  multiline={false}
                  required={false}
                  type={""}
                  rows={1}
                  value={apiParams.cardId}
                  disabled={false}
                />
              </div>
            </div>
            <div className={classes.cardInfo}>
              <div style={foreColor(user?.mode ?? "lite")}>TYPE</div>
              <div className={classes.textField}>
                <TextInputForCard
                  fullWidth={false}
                  label={""}
                  multiline={false}
                  required={false}
                  type={""}
                  rows={1}
                  value={apiParams.cardType}
                  disabled={false}
                />
              </div>
            </div>
            <div className={classes.compDate}>
              <div style={foreColorOnMouseOver(user?.mode ?? "lite")}>
                {isFound ? "変更後の工程" : "新規登録する工程"}
              </div>
              <div className={classes.textField}>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  value={compDate}
                  onChange={(e) =>
                    handleSelectBoxChange(e.target.value as string)
                  }
                  sx={{
                    px: 0,
                    py: 0,
                    mx: 0,
                    my: 0,
                    boxShadow:
                      user?.mode === "lite"
                        ? "0px 0px 3px 1px #898b92"
                        : "0px 0px 3px 1px black",
                    color: foreColorCodeLite(user?.mode ?? "dark"),
                    height: "38px",
                    width: "240px",
                    fontSize: "0.8rem",
                    "& .MuiSvgIcon-root": {
                      color: foreColorCodeLite(user?.mode ?? "dark"),
                    },
                    "&icon": {
                      color: "blue",
                    },
                    borderRadius: "5px",
                    backgroundColor: backGroundColorCode(user?.mode ?? "dark"),

                    "& .MuiSelect-select": {
                      color: foreColorCodeLite(user?.mode ?? "dark"),
                      // backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // 選択エリアの背景色を設定
                      // maxheight: "0px",
                    },
                    "&.Mui-selected": {
                      backgroundColor: backGroundColorCode(
                        user?.mode ?? "dark"
                      ), // 選択時の背景色を変更
                      color: foreColorCode(user?.mode ?? "dark"), // 選択時の文字色を変更
                    },

                    // ホバー状態のスタイルも定義できます
                    "&:hover": {
                      backgroundColor: backGroundColorCode(
                        user?.mode ?? "dark"
                      ), // ホバー時の背景色を変更
                      color: foreColorCode(user?.mode ?? "dark"), // ホバー時の文字色を変更
                    },
                    // 選択されていてさらにホバーされた状態のスタイル
                    "&.Mui-selected:hover": {
                      backgroundColor: backGroundColorCode(
                        user?.mode ?? "dark"
                      ), // 選択 + ホバー時の背景色
                      color: foreColorCode(user?.mode ?? "dark"), // 選択 + ホバー時の文字色
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        backgroundColor: backGroundColorCode(
                          user?.mode ?? "dark"
                        ),

                        // 他のスタイルもここで指定できます。
                      },
                    },
                  }}
                >
                  {completeDateList.map((completeDate) => (
                    <MenuItem
                      key={completeDate.id}
                      value={completeDate.id}
                      sx={{
                        color: foreColorCodeLite(user?.mode ?? "dark"),
                        height: "38px",
                        width: "240px",
                        fontSize: "0.8rem",
                        "& .MuiSvgIcon-root": {
                          color: foreColorCodeLite(user?.mode ?? "dark"),
                        },
                        "&icon": {
                          color: "blue",
                        },
                        borderRadius: "5px",
                        backgroundColor: backGroundColorCode(
                          user?.mode ?? "dark"
                        ),

                        "& .MuiSelect-select": {
                          color: foreColorCodeLite(user?.mode ?? "dark"),
                          // backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // 選択エリアの背景色を設定
                          // maxheight: "0px",
                        },
                        "&.Mui-selected": {
                          backgroundColor: backGroundColorCode(
                            user?.mode ?? "dark"
                          ), // 選択時の背景色を変更
                          color: foreColorCode(user?.mode ?? "dark"), // 選択時の文字色を変更
                        },

                        // ホバー状態のスタイルも定義できます
                        "&:hover": {
                          backgroundColor: backGroundColorCode(
                            user?.mode ?? "dark"
                          ), // ホバー時の背景色を変更
                          color: foreColorCode(user?.mode ?? "dark"), // ホバー時の文字色を変更
                        },
                        // 選択されていてさらにホバーされた状態のスタイル
                        "&.Mui-selected:hover": {
                          backgroundColor: backGroundColorCode(
                            user?.mode ?? "dark"
                          ), // 選択 + ホバー時の背景色
                          color: foreColorCode(user?.mode ?? "dark"), // 選択 + ホバー時の文字色
                        },
                      }}
                    >
                      {completeDate.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
            <div className={classes.spacer} />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ margin: "10px" }}>
                <DialogButton
                  label={isFound ? "更新" : "追加"}
                  disabled={compDate !== "未登録" ? false : true}
                  onClick={handleOKButtonClick}
                  width={96}
                  colorStyle={"yesColor"}
                />
              </div>
              <div style={{ margin: "10px" }}>
                <DialogButton
                  label={"ｷｬﾝｾﾙ"}
                  width={96}
                  disabled={false}
                  onClick={handleCancelButtonClick}
                  colorStyle={"noColor"}
                />
              </div>
            </Box>
          </Stack>
        </div>
      )}
    </>
  );
};

export default CardRegistration;
